/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ridge_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overlapping ridges give the plot its characteristic mountain-range look.`)
};

const es_ridge_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las crestas superpuestas dan al gráfico su característico aspecto de cadena montañosa.`)
};

const de_ridge_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überlappende Grate verleihen dem Diagramm sein charakteristisches Gebirgszug-Aussehen.`)
};

const nl_ridge_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overlappende richels geven de plot zijn kenmerkende bergketen-uitstraling.`)
};

const fr_ridge_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les crêtes qui se chevauchent donnent au graphique son allure caractéristique de chaîne de montagnes.`)
};

const it_ridge_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I ridge sovrapposti danno al grafico il suo caratteristico aspetto a catena montuosa.`)
};

const pt_br2_ridge_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cristas sobrepostas dão ao gráfico seu visual característico de cadeia de montanhas.`)
};

const pt_ridge_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As cristas sobrepostas dão ao gráfico o seu aspeto característico de cordilheira.`)
};

const ja_ridge_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リッジ同士が重なり合うことで、このプロット特有の山脈のような見た目になります。`)
};

const zh_ridge_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重叠的山脊赋予该图特有的山脉般的外观。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ridge_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ridge_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ridge_ex3", locale)
	if (locale === "en") return en_ridge_ex3(inputs)
	if (locale === "es") return es_ridge_ex3(inputs)
	if (locale === "de") return de_ridge_ex3(inputs)
	if (locale === "nl") return nl_ridge_ex3(inputs)
	if (locale === "fr") return fr_ridge_ex3(inputs)
	if (locale === "it") return it_ridge_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_ridge_ex3(inputs)
	if (locale === "pt") return pt_ridge_ex3(inputs)
	if (locale === "ja") return ja_ridge_ex3(inputs)
	return zh_ridge_ex3(inputs)
};